import { createContext } from 'react';

import type { TableInstance } from 'react-table';

const TableInstanceContext = createContext<TableInstance<any>>(null as any);

export default TableInstanceContext;
